























import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';
import { BaseService } from '@/api/com/MetaPattern/MDA/MD/Base/BaseService';
import { GuidHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/GuidHelper';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';

@Component({
  components: {
  }
})
export default class WorkScopeEdit extends Vue {
  @Prop() entity!: WorkScope; // 编辑的工作空间，为空则新建
  private workScope: WorkScope = null;

  constructor() {
    super();
    if (!this.entity) {
      this.workScope = new WorkScope();
      this.workScope.designId = GuidHelper.getGuid();
      this.workScope.persistenceStatus = EnumPersistenceStatus.Create;
    } else {
      this.workScope = this.entity;
    }
  }

  mounted() {
    if (!this.entity) {
      this.workScope = new WorkScope();
      this.workScope.designId = GuidHelper.getGuid();
      this.workScope.persistenceStatus = EnumPersistenceStatus.Create;
    } else {
      this.workScope = this.entity;
    }
  }

  validateName(rule: any, value: string, callback: any) {
    ValidateHelper.validateExpressWithCallback('^[a-zA-Z]{1}[a-zA-Z0-9]{5,15}$', '名称必须至少6位且包含字母和数字，以字母开头，最长16位', value, callback);
  }

  cancel() {
    (this.$refs.workScope as any).resetFields();
    this.$emit('closeDialog', null);
  }

  confirm() {
    (this.$refs.workScope as any).validate((valid: any) => {
      if (valid) {
        BaseService.SaveWorkScopeAsync(this.workScope)
          .then((item: WorkScope) => {
            this.workScope = item;
            this.$message({ type: 'success', message: '保存成功!' });
            this.$emit('closeDialog', this.workScope);
          })
          .catch(error => {
            console.log(error);
            this.$message({ type: 'error', message: '保存失败!原因是：' + error });
          });
      } else {
        return false;
      }
    });
  }

  get labelWidth() {
    return '100px';
  }

  get canEdit() {
    const findApp = this.$store.state.ModuleMD.apps.find((app: APP) => app.workScope_ID === this.workScope.id);
    if (findApp) {
      return false;
    }
    const findProduct = this.$store.state.ModuleMD.products.find((product: Product) => product.workScope_ID === this.workScope.id);
    if (findProduct) {
      return false;
    }
    return this.workScope.persistenceStatus === EnumPersistenceStatus.Create;
  }
}

